import CPSStatementGenerator from "./pages/CPSStatementGenerator/CPSStatementGenerator";


function App() {
  return (
    <div className="App">
      <CPSStatementGenerator />
    </div>
  );
}

export default App;
